/*
 * VAYORA — Set-Baukasten (sections/vayora-kit.liquid) e Kombis da home (sections/vayora-kits-home.liquid).
 * Kombis: tamanho em comum, cor por peça, preço pelas regras da loja e um botão que põe tudo no carrinho.
 * Página do Set-Baukasten: cada "+" adiciona a peça no carrinho de verdade e a barra fixa é refeita a partir do /cart.js,
 * então total e descontos são sempre os que a Shopify aplica. Sugestão: uma por vez, na ordem
 * 3./5. peça grátis → BH no look → frete grátis.
 * Home: carrossel com troca automática no celular, que para de vez quando a cliente mexe nele (deslizar para o lado,
 * tocar num pontinho ou escolher tamanho/cor). Rolar a página com o dedo em cima dos cartões não conta.
 */
(() => {
  const root = document.querySelector('[data-vk]');
  const home = document.querySelector('[data-vkh]');
  const scope = root || home;
  if (!scope) return;

  const moneyFormat = scope.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
  const money = (cents) => {
    const value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (key.includes('comma') ? value.replace('.', ',') : value));
  };
  const lookBottoms = scope.dataset.lookBottoms.split(',');
  const lookBras = scope.dataset.lookBras.split(',');

  // Adiciona no carrinho pelo mesmo caminho de assets/vayora-cart.js. Na home abre a gaveta; na página, a barra mostra o resultado.
  const addToCart = async (items) => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    const response = await fetch(`${theme.routes.cart_add_url}`, { ...theme.utils.fetchConfig(), body: JSON.stringify({ items, sections }) });
    const added = await response.json();
    if (added.status) throw new Error(added.description || added.message);
    const cart = await (await fetch(`${theme.routes.cart_url}`, { ...theme.utils.fetchConfig() })).json();
    cart.sections = added.sections;
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
    if (!root) document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added } }));
    if (root) await refresh();
  };

  // ---------- Kombis ----------
  // Regras da loja: pacote 2+1 / 3+2 por produto e Look 10 € no BH quando peça de baixo e BH estão fora do pacote.
  // Os bônus por valor (ab 150 € / ab 200 €) foram desativados em 2026-10-29. Conferido no carrinho real em 2026-10-25.
  // Produto com metacampo custom.mengenrabatt (ex.: Core Pulstrainer {"2":20,"3":30}) usa desconto percentual por peça,
  // arredondado para baixo como a Shopify, no lugar do pacote.
  const kitPrice = (lines) => {
    let sub = 0;
    let orig = 0;
    for (const l of lines) {
      orig += l.prices.reduce((sum, price) => sum + price, 0);
      if (l.tiers) {
        const pct = Object.entries(l.tiers).reduce((best, [min, value]) => (l.qty >= Number(min) ? Math.max(best, Number(value)) : best), 0);
        sub += l.prices.reduce((sum, price) => sum + price - Math.floor((price * pct) / 100 + 1e-9), 0);
        continue;
      }
      const free = l.qty >= 5 ? 2 : l.qty >= 3 ? 1 : 0;
      sub += l.prices[0] * (l.qty - free);
    }
    const openBottom = lines.some((l) => lookBottoms.includes(l.handle) && l.qty !== 3 && l.qty !== 5);
    // O Look só entra se houver peça de baixo E BH fora do pacote (com 3 ou 5 unidades o pacote consome todas; testado no carrinho)
    const openBra = lines.some((l) => lookBras.includes(l.handle) && l.qty !== 3 && l.qty !== 5);
    if (openBottom && openBra) sub -= 1000;
    return { total: sub, orig };
  };

  scope.querySelectorAll('[data-vk-kit]').forEach((kit) => {
    const items = [...kit.querySelectorAll('[data-vk-kit-item]')].map((el) => {
      const data = JSON.parse(el.querySelector('[data-vk-variants]').textContent);
      const size = data.options.indexOf('Größe');
      let color = data.options.indexOf('Farbe');
      // Opção única que não é cor nem tamanho (ex.: "Set") funciona como a cor: um seletor por peça.
      if (color < 0 && size < 0 && data.options.length === 1) color = 0;
      return { el, qty: Number(el.dataset.qty), handle: el.dataset.handle, tiers: JSON.parse(el.dataset.tiers || 'null'), ...data, color, size };
    });
    const sizeSelect = kit.querySelector('[data-vk-kit-size]');
    const button = kit.querySelector('[data-vk-kit-add]');
    const sizesOf = (item) => [...new Set(item.variants.filter((v) => v.available).map((v) => v.options[item.size]))];
    const sizes = items.reduce((acc, item) => acc.filter((s) => sizesOf(item).includes(s)), sizesOf(items[0]));
    sizeSelect.replaceChildren(...sizes.map((s) => Object.assign(document.createElement('option'), { value: s, textContent: `Größe ${s}` })));
    // Kombi sem tamanho (ex.: Core Pulstrainer): sem seletor de tamanho.
    sizeSelect.hidden = items.every((item) => item.size < 0);
    // Uma variante por peça: cada unidade tem o seu seletor de cor (o pacote aceita cores misturadas).
    const variantFor = (item, colorSelect) => item.variants.find((v) => v.available && (item.size < 0 || v.options[item.size] === sizeSelect.value) && (!colorSelect || item.color < 0 || v.options[item.color] === colorSelect.value));
    const unitsOf = (item) => {
      const selects = [...item.el.querySelectorAll('[data-vk-kit-color]')];
      return Array.from({ length: item.qty }, (_, i) => variantFor(item, selects[i] || selects[0]));
    };
    const update = () => {
      const chosen = items.map((item) => ({ item, units: unitsOf(item) }));
      const ok = chosen.every((c) => c.units.every(Boolean));
      button.disabled = !ok;
      if (!ok) { button.textContent = 'Nicht verfügbar'; return; }
      button.textContent = 'Kombi hinzufügen';
      const { total, orig } = kitPrice(chosen.map((c) => ({ handle: c.item.handle, qty: c.item.qty, prices: c.units.map((u) => u.price), tiers: c.item.tiers })));
      kit.querySelector('[data-vk-kit-total]').textContent = money(total);
      kit.querySelector('[data-vk-kit-compare]').textContent = orig > total ? money(orig) : '';
      kit.querySelector('[data-vk-kit-save]').textContent = orig > total ? `Du sparst ${money(orig - total)}` : '';
    };
    kit.addEventListener('change', update);
    button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        const qty = new Map();
        items.forEach((item) => unitsOf(item).forEach((v) => qty.set(v.id, (qty.get(v.id) || 0) + 1)));
        await addToCart([...qty].map(([id, quantity]) => ({ id, quantity })));
        button.classList.add('is-added');
        button.textContent = '✓ Im Warenkorb';
        setTimeout(() => { button.classList.remove('is-added'); button.textContent = 'Kombi hinzufügen'; }, 1600);
      } catch (error) {
        console.log(error);
      } finally {
        button.disabled = false;
      }
    });
    update();
  });

  // ---------- Home: carrossel com troca lenta automática ----------
  if (home) {
    const track = home.querySelector('[data-vk-track]');
    const dotsBox = home.querySelector('[data-vk-dots]');
    const cards = [...track.querySelectorAll('[data-vk-kit]')];
    const seconds = Number(home.dataset.autoplay) || 0;
    const index = () => {
      const left = track.scrollLeft;
      let best = 0;
      cards.forEach((c, i) => { if (Math.abs(c.offsetLeft - track.offsetLeft - left) < Math.abs(cards[best].offsetLeft - track.offsetLeft - left)) best = i; });
      return best;
    };
    const goTo = (i) => track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    const dots = cards.map((_, i) => {
      const dot = Object.assign(document.createElement('button'), { type: 'button' });
      dot.setAttribute('aria-label', `Kombi ${i + 1}`);
      dot.addEventListener('click', () => { stop(); goTo(i); });
      return dot;
    });
    dotsBox.replaceChildren(...dots);
    const paint = () => { const i = index(); dots.forEach((d, n) => d.setAttribute('aria-current', String(n === i))); };
    track.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true });
    paint();

    let timer = null;
    let visible = false;
    let stopped = !seconds || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const tick = () => {
      if (stopped || !visible || document.hidden || track.scrollWidth <= track.clientWidth + 4) return;
      goTo((index() + 1) % cards.length);
    };
    function stop() { stopped = true; clearInterval(timer); }
    // Para só com interação de verdade: escolher tamanho/cor, clicar (o clique não dispara depois de rolar a página)
    // ou deslizar o carrossel para o lado. touchstart/pointerdown sozinhos também acontecem ao rolar a página.
    ['click', 'change'].forEach((type) => track.addEventListener(type, stop, { passive: true }));
    track.addEventListener('wheel', (e) => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stop(); }, { passive: true });
    let touchX = null;
    let touchY = null;
    track.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; }, { passive: true });
    track.addEventListener('touchmove', (e) => {
      if (touchX === null) return;
      const dx = Math.abs(e.touches[0].clientX - touchX);
      const dy = Math.abs(e.touches[0].clientY - touchY);
      if (dx > 10 && dx > dy) { stop(); touchX = null; }
    }, { passive: true });
    new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }, { threshold: 0.5 }).observe(track);
    if (!stopped) timer = setInterval(tick, seconds * 1000);
  }

  if (!root) return;

  // ---------- Página Set-Baukasten: abas, "+" por produto e barra ----------
  const tip = root.querySelector('[data-vk-tip]');
  const tipBtn = root.querySelector('[data-vk-tip-btn]');
  const chips = root.querySelector('[data-vk-chips]');
  const itemCount = root.querySelector('[data-vk-itemcount]');
  const totalEl = root.querySelector('[data-vk-total]');
  const go = root.querySelector('[data-vk-go]');
  let tipAction = null;

  const showTab = (id) => {
    root.querySelectorAll('[data-vk-tab]').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.vkTab === id)));
    root.querySelectorAll('[data-vk-panel]').forEach((p) => { p.hidden = p.dataset.vkPanel !== id; });
  };
  root.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-vk-tab]');
    if (tab) showTab(tab.dataset.vkTab);
  });

  // Farbe/Größe escolhem a variante do "+"
  root.addEventListener('change', (event) => {
    if (!event.target.matches('[data-vk-opt]')) return;
    const card = event.target.closest('[data-vk-card]');
    const variants = JSON.parse(card.querySelector('[data-vk-variants]').textContent);
    const chosen = [...card.querySelectorAll('[data-vk-opt]')].map((s) => s.value);
    const variant = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    const button = card.querySelector('[data-vk-add]');
    button.disabled = !variant || !variant.available;
    if (variant) {
      button.dataset.vkAdd = variant.id;
      card.querySelector('[data-vk-price]').textContent = money(variant.price);
    }
  });

  root.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vk-add]');
    if (!button || button.disabled) return;
    button.disabled = true;
    try {
      await addToCart([{ id: Number(button.dataset.vkAdd), quantity: 1 }]);
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 900);
    } catch (error) {
      console.log(error);
    } finally {
      button.disabled = false;
    }
  });

  tipBtn.addEventListener('click', async () => {
    if (!tipAction) return;
    if (tipAction.tab) {
      showTab(tipAction.tab);
      root.querySelector('.vk__tabs').scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    tipBtn.disabled = true;
    try {
      await addToCart([{ id: Number(tipAction.variant), quantity: tipAction.qty }]);
    } catch (error) {
      console.log(error);
    } finally {
      tipBtn.disabled = false;
    }
  });

  const chipFor = (title) => {
    // Desconto percentual por quantidade (ex.: "2 Stück −20 % · VAYORA Core Pulstrainer")
    const pct = title.match(/^(\d+) Stück −(\d+) %/);
    if (pct) return `−${pct[2]} % ab ${pct[1]} Stück`;
    if (/^2 Stück/.test(title)) return '2+1 gratis';
    if (/^3 Stück/.test(title)) return '3+2 gratis';
    if (/^Look/.test(title)) return 'Look −10 €';
    return null;
  };

  const braTabId = () => {
    const card = [...root.querySelectorAll('[data-vk-card]')].find((c) => lookBras.some((h) => c.querySelector('a.vk-card__name').getAttribute('href').endsWith(`/products/${h}`)));
    return card ? card.closest('[data-vk-panel]').dataset.vkPanel : null;
  };

  const suggestion = (cart) => {
    if (!cart.item_count) return { text: 'Wähle dein erstes Teil – alle Rabatte ziehen wir automatisch ab.' };
    const products = new Map();
    for (const item of cart.items) {
      const p = products.get(item.product_id) || { qty: 0, title: item.product_title, variant: item.variant_id, handle: item.handle };
      p.qty += item.quantity;
      products.set(item.product_id, p);
    }
    // Produtos com desconto percentual (metacampo custom.mengenrabatt) não têm "3. gratis": sugere a próxima faixa de %.
    const tiersOf = (id) => {
      const card = root.querySelector(`[data-vk-card][data-product-id="${id}"]`);
      return card ? JSON.parse(card.dataset.tiers || 'null') : null;
    };
    for (const [id, p] of products) {
      const tiers = tiersOf(id);
      if (tiers) {
        const next = Object.entries(tiers).map(([min, value]) => [Number(min), Number(value)]).sort((a, b) => a[0] - b[0]).find(([min]) => min > p.qty);
        if (next) return { text: `Noch ${next[0] - p.qty}× ${p.title} – ab ${next[0]} Stück ${next[1]} % Rabatt!`, button: `+${next[0] - p.qty}`, action: { variant: p.variant, qty: next[0] - p.qty } };
        continue;
      }
      if (p.qty === 2) return { text: `Noch 1× ${p.title} – das 3. ist gratis!`, button: '+1', action: { variant: p.variant, qty: 1 } };
      if (p.qty === 4) return { text: `Noch 1× ${p.title} – das 5. ist gratis!`, button: '+1', action: { variant: p.variant, qty: 1 } };
    }
    const hasBra = [...products.values()].some((p) => lookBras.includes(p.handle));
    const openBottom = [...products.values()].some((p) => lookBottoms.includes(p.handle) && p.qty !== 3 && p.qty !== 5);
    const tab = braTabId();
    if (openBottom && !hasBra && tab) return { text: 'BH dazu – im Look 10 € günstiger', button: 'BHs ansehen', action: { tab } };
    // BH fora do pacote, mas a peça de baixo está toda no pacote (3 ou 5): +1 peça libera o Look (igual ao aviso do carrinho)
    const openBra = [...products.values()].some((p) => lookBras.includes(p.handle) && p.qty !== 3 && p.qty !== 5);
    const packedBottom = [...products.values()].find((p) => lookBottoms.includes(p.handle) && (p.qty === 3 || p.qty === 5));
    if (openBra && !openBottom && packedBottom) return { text: `Noch 1× ${packedBottom.title} – und spar 10 € auf deinen BH`, button: '+1', action: { variant: packedBottom.variant, qty: 1 } };
    if (cart.total_price < 10000) return { text: `Noch ${money(10000 - cart.total_price)} bis Gratis-Versand` };
    return { text: '✓ Du sparst das Maximum!' };
  };

  const render = (cart) => {
    const tipData = suggestion(cart);
    tip.textContent = tipData.text;
    tipAction = tipData.action || null;
    tipBtn.hidden = !tipData.button;
    tipBtn.textContent = tipData.button || '';

    const labels = new Set();
    for (const item of cart.items) for (const d of item.line_level_discount_allocations || []) { const c = chipFor(d.discount_application.title); if (c) labels.add(c); }
    for (const d of cart.cart_level_discount_applications || []) { const c = chipFor(d.title); if (c) labels.add(c); }
    if (cart.item_count && cart.total_price >= 10000) labels.add('Gratis-Versand');
    chips.replaceChildren(...[...labels].map((label) => Object.assign(document.createElement('span'), { textContent: `✓ ${label}` })));

    itemCount.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'Teil' : 'Teile'}`;
    totalEl.textContent = money(cart.total_price);
    if (cart.original_total_price > cart.total_price) {
      totalEl.append(' ', Object.assign(document.createElement('s'), { textContent: money(cart.original_total_price) }));
    }
    go.setAttribute('aria-disabled', String(!cart.item_count));

    const counts = {};
    for (const item of cart.items) counts[item.product_id] = (counts[item.product_id] || 0) + item.quantity;
    root.querySelectorAll('[data-vk-card]').forEach((card) => {
      const badge = card.querySelector('[data-vk-count]');
      const q = counts[card.dataset.productId] || 0;
      badge.hidden = !q;
      badge.textContent = `${q}× im Set`;
    });
  };

  async function refresh() {
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      render(cart);
    } catch (error) {
      console.log(error);
    }
  }

  // Mudanças feitas pela gaveta do carrinho também atualizam a barra
  if (window.theme && theme.pubsub) theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => refresh());
  refresh();
})();
